import React, { createContext, useState } from "react";
import PropTypes from "prop-types";

const HeaderContext = createContext({
  isOpenSearch: false,
  setIsOpenSearch: () => null,
});

const HeaderProvider = ({ children }) => {
  const [isOpenSearch, setIsOpenSearch] = useState(false);

  const value = { isOpenSearch, setIsOpenSearch };
  return (
    <HeaderContext.Provider value={value}>{children}</HeaderContext.Provider>
  );
};

HeaderProvider.displayName = "HeaderContext";

HeaderProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { HeaderContext, HeaderProvider };
